import { Map } from "immutable";
import Widget from "views/logic/widgets/Widget";
import TextWidgetConfig from "views/logic/widgets/TextWidgetConfig";
const _TextWidget = class _TextWidget extends Widget {
  constructor(id, config, filter, timerange, query, streams, streamCategories, filters, description, context) {
    super(
      id,
      _TextWidget.type,
      config,
      filter,
      timerange,
      query,
      streams,
      streamCategories,
      filters,
      description,
      context
    );
  }
  static fromJSON(value) {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = value;
    return new _TextWidget(
      id,
      TextWidgetConfig.fromJSON(config),
      filter,
      timerange,
      query,
      streams,
      stream_categories,
      filters,
      description,
      context
    );
  }
  equals(other) {
    if (other instanceof _TextWidget) {
      return this._value.id === other.id && this._value.config.equals(other.config);
    }
    return false;
  }
  equalsForSearch(other) {
    return other instanceof _TextWidget && this._value.config.equalsForSearch(other.config);
  }
  toBuilder() {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = this._value;
    return new Builder(
      Map({ id, config, filter, timerange, query, streams, stream_categories, filters, description, context })
    );
  }
  static builder() {
    return new Builder();
  }
};
_TextWidget.type = "text";
_TextWidget.defaultTitle = "Untitled Text Widget";
let TextWidget = _TextWidget;
export {
  TextWidget as default
};
class Builder extends Widget.Builder {
  build() {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = this.value.toObject();
    return new TextWidget(
      id,
      config,
      filter,
      timerange,
      query,
      streams,
      stream_categories,
      filters,
      description,
      context
    );
  }
}
